const CaseIdentityCard = () =>
  import("@/components/atm-front/cases/case/CaseIdentityCard/CaseIdentityCard.vue");

const MissionPermea = () =>
  import("@/components/atm-front/cases/case/MissionPermea/MissionPermea.vue");

const Documents = () => import("@/components/atm-front/cases/case/Documents/Documents.vue");

const MissionDPE = () => import("@/components/atm-front/cases/case/MissionDPE/MissionDPE.vue");

const MissionVentilation = () =>
  import("@/components/atm-front/cases/case/MissionVentilation/MissionVentilation.vue");

const MissionRE2020 = () =>
  import("@/components/atm-front/cases/case/MissionRE2020/MissionRE2020.vue");

const Acoustic = () => import("@/components/atm-front/cases/case/Acoustic/Acoustic.vue");

const Contributors = () =>
  import("@/components/atm-front/cases/case/Contributors/Contributors.vue");

const Reports = () => import("@/components/atm-front/cases/case/Reports/Reports.vue");

import AcousticChildren from "./acoustic/acoustic-children";
import CaseIdentityCardChildren from "./case-identity-card/case-identity-card-children";
import ReportsChildren from "./reports/reports-children";

export default [
  {
    path: "identity-card",
    name: "CaseIdentityCard",
    component: CaseIdentityCard,
    redirect: { name: "CaseIdentityCardDefault" },
    children: CaseIdentityCardChildren,
  },
  {
    path: "documents",
    name: "Documents",
    component: Documents,
  },
  {
    path: "contributors",
    name: "Contributors",
    component: Contributors,
  },
  {
    path: "reports",
    name: "Reports",
    component: Reports,
    redirect: { name: "ReportList" },
    children: ReportsChildren,
  },
  {
    path: "mission-permea",
    name: "MissionPermea",
    component: MissionPermea,
  },
  {
    path: "mission-dpe",
    name: "MissionDPE",
    component: MissionDPE,
  },
  {
    path: "mission-ventilation",
    name: "MissionVentilation",
    component: MissionVentilation,
  },
  {
    path: "mission-re2020",
    name: "MissionRE2020",
    component: MissionRE2020,
  },
  {
    path: "acoustic",
    name: "Acoustic",
    component: Acoustic,
    redirect: { name: "Operation" },
    children: AcousticChildren,
  },
];
